<template>
    <tr class="module__list_table_item">
        <td class="module__list_table_name">{{moduleName}}</td>
        <td class="module__list_table_description">
            <component-text
                :read-more-active="true"
                :read-more-limit="125"
            >{{ moduleDescription }}
            </component-text>
        </td>
        <td class="module__list_table_duration">{{moduleDuration}}</td>
        <td class="module__list_table_labels">
            <component-text-list
                :items="moduleLabels"
                :limit-active="true"
            ></component-text-list>
        </td>
        <td class="module__list_table_keywords">
            <component-text
                :read-more-active="true"
                :read-more-limit="125"
            >{{ moduleKeywords }}
            </component-text>
        </td>
        <td class="module__list_table_status">
            <component-status :status="moduleDeleted ? 'archived' : 'active'"></component-status>
        </td>
        <td class="module__list_table_actions">
            <div class="columns is-vcentered">
                <div class="column"></div>
                <div class="column is-narrow">
                    <component-button
                        :theme="'default'"
                        :to="{ name: 'ebs-module-show', params: { id: moduleId } }"
                        :name="`module-list-table-actions-view-${moduleId}`"
                    >View
                    </component-button>
                </div>
                <template v-if="user.isCourseCreator()">
                    <div class="column is-narrow">
                        <component-button-menu
                            :buttons="[
                                {
                                    key: 'create-new-version',
                                    name: 'Edit module',
                                    visible: !moduleIsDraftVersion
                                },
                                {
                                    key: 'view-usage',
                                    name: 'View usage'
                                },
                                {
                                    key: 'edit-draft',
                                    name: 'Edit draft',
                                    visible: moduleIsDraftVersion
                                },
                                {
                                    key: '',
                                    name: ''
                                },
                                {
                                    key: 'archive-module',
                                    name: 'Archive module',
                                    danger: true,
                                    visible: !moduleDeleted
                                },
                                {
                                    key: 'reactivate-module',
                                    name: 'Re-activate module',
                                    icon: true,
                                    iconName: 'refresh-cw',
                                    visible: moduleDeleted
                                }
                            ]"
                            @emit-create-new-version="redirectToCreateNewVersion"
                            @emit-edit-draft="redirectToEditDraft"
                            @emit-view-usage="redirectToViewUsage"
                            @emit-archive-module="performEmit('emit-archive-module', { moduleId, moduleName, moduleIncludedInCourses })"
                            @emit-reactivate-module="performEmit('emit-reactivate-module', { moduleId })"
                        ></component-button-menu>
                    </div>
                </template>
            </div>
        </td>
    </tr>
</template>

<script>
import ComponentButton from '@/components/default/shared/ComponentButton'
import { User } from '@/User'
import ComponentButtonMenu from '@/components/default/shared/ComponentButtonMenu'
import ComponentText from '@/components/default/shared/ComponentText'
import ComponentTextList from '@/components/default/shared/ComponentTextList'
import ComponentStatus from "@/components/default/shared/ComponentStatus";

export default {
  components: { ComponentStatus, ComponentTextList, ComponentText, ComponentButtonMenu, ComponentButton },
  name: 'module-list-table-item',
  data () {
    return {
      user: new User()
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    moduleId () {
      return this.item.id
    },
    moduleIncludedInCourses () {
      return this.item.includedInCourses
    },
    moduleName () {
      return this.item.name
    },
    moduleDescription () {
      return this.item.description
    },
    moduleDuration () {
      return this.item.duration
    },
    moduleDeleted () {
      return this.item.deleted
    },
    moduleKeywords () {
      return this.item.keywords
    },
    moduleLabels () {
      return this.item.label ? this.item.label.map(obj => Object.values(obj)[0]) : []
    },
    moduleIsDraftVersion () {
      return Boolean(this.item.draft)
    }
  },
  methods: {
    redirectToCreateNewVersion () {
      this.$router.push({ name: 'ebs-module-edit', params: { id: this.moduleId }, query: { type: 'new-version' } })
    },
    redirectToEditDraft () {
      this.$router.push({ name: 'ebs-module-edit', params: { id: this.moduleId }, query: { type: 'edit-draft' } })
    },
    redirectToViewUsage () {
      this.$router.push({ name: 'ebs-course-list', query: { modules: `${this.moduleId};${this.moduleName}` } })
    },
    performEmit (message, value) {
      this.$emit('emit', { message: message, value: value })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/modules/modulelisttableitem";
</style>
